type NetInfoConnection = {
  effectiveType?: string;
  downlink?: number;
  rtt?: number;
  saveData?: boolean;
};

const getNetworkContext = () => {
  const ctx: Record<string, unknown> = {
    online: typeof navigator !== "undefined" ? navigator.onLine : undefined,
  };
  const conn = (navigator as unknown as { connection?: NetInfoConnection })
    .connection;
  if (conn) {
    ctx.effectiveType = conn.effectiveType;
    ctx.downlink = conn.downlink;
    ctx.rtt = conn.rtt;
    ctx.saveData = conn.saveData;
  }
  return ctx;
};

export const captureError = (message: string, error: unknown) => {
  import("@sentry/react")
    .then((Sentry) => {
      Sentry.withScope((scope) => {
        scope.setLevel("error");
        scope.setTag("capture_context", message);
        scope.setExtra("context", message);
        scope.setContext("network", getNetworkContext());

        if (error instanceof Error) {
          Sentry.captureException(error);
          return;
        }

        let serialized: string;
        try {
          serialized = JSON.stringify(error);
          scope.setExtra("error", JSON.parse(serialized));
        } catch {
          serialized = String(error);
          scope.setExtra("error", serialized);
        }
        Sentry.captureException(new Error(`${message}: ${serialized}`));
      });
    })
    .catch(() => {
      console.error(message, error);
    });
};
